module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"修改密码":"Change Password","语言":"Language","退出":"Sign Out"}}')
  delete Component.options._Ctor
}
